import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { registerTravelServiceWorker } from './features/offline/registerTravelServiceWorker';
import './styles/tokens.css';
import './styles/responsive.css';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerTravelServiceWorker();
